import React, { useEffect, useState } from 'react';

const PaymentSuccess = () => {
  const [registrationCode, setRegistrationCode] = useState('');
  const [route, setRoute] = useState('');

  useEffect(() => {
    try {
      const pending = sessionStorage.getItem('pendingRegistration');
      if (pending) {
        const data = JSON.parse(pending);
        if (data.registrationCode) {
          setRegistrationCode(data.registrationCode);
        }
        if (data.route) {
          setRoute(data.route);
        }
        sessionStorage.removeItem('pendingRegistration');
      }
    } catch (err) {
      console.error('Error reading session storage:', err);
    }
  }, []);

  const isMilanOnly = route === 'jerusalem-milan' || route === 'milan';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
            <svg
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          {/* Success Message */}
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Payment Received
            </h2>
            <p className="text-gray-600 mb-6">
              Thank you for your payment. You will receive a confirmation email within 12 hours.
              Please note: <strong>you only have a confirmed ticket once you receive the confirmation email.</strong>
            </p>

            {/* Registration Code */}
            {registrationCode && (
              <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6">
                <h4 className="text-lg font-semibold text-green-800 mb-2">Your Registration Code:</h4>
                <div className="text-2xl font-mono font-bold text-green-900 bg-white rounded p-3 border">
                  {registrationCode}
                </div>
                <p className="text-sm text-green-700 mt-2">
                  Please save this code for your records and reference in all communications.
                </p>
              </div>
            )}

            {/* Milan-only: connecting flight warning */}
            {isMilanOnly && (
              <div className="bg-amber-50 border border-amber-300 rounded-lg p-5 mb-6 text-left">
                <h4 className="text-base font-semibold text-amber-800 mb-3">Important: Connecting Flights from Milan</h4>
                <p className="text-sm text-amber-900 mb-2">
                  <strong>Recommended Connection Time:</strong> We strongly recommend that you do not book any connecting flights departing before 2:00 PM. This window allows for necessary buffer time in the event of unforeseen delays.
                </p>
                <p className="text-sm text-amber-900">
                  <strong>Self-Connection Policy:</strong> Please be advised that Plan It Rite cannot accept any responsibility or liability for self-booked connecting flights. Travelers who choose to book their own separate connections do so at their own risk regarding potential delays or missed departures.
                </p>
              </div>
            )}

            {/* Contact Information */}
            <div className="text-center text-sm text-gray-500">
              <p>Questions? Contact us at:</p>
              <p className="font-medium">
                <a href="mailto:flights@igudys.com" className="text-blue-600 hover:text-blue-800 underline">
                  flights@igudys.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
